import { render, staticRenderFns } from "./promot.vue?vue&type=template&id=021cba4b&scoped=true"
import script from "./promot.vue?vue&type=script&lang=js"
export * from "./promot.vue?vue&type=script&lang=js"
import style0 from "./promot.vue?vue&type=style&index=0&id=021cba4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cba4b",
  null
  
)

export default component.exports